/**
 * Restructed by he.zhikai
 * Restructed on 2017-11-24
 */
'use strict';
angular
    .module('newspaperRemarkChannelModule', [
        'newspaperRemarkChannelLeftModule',
    ])
    .controller('newspaperRemarkChannelCtrl', [
        '$scope',
        '$q',
        function (
            $scope,
            $q
        ) {
            initStatus();
            initData();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
            }
        }
    ]);
